export default "__VITE_ASSET__CdMUVWSh__"